import { render, staticRenderFns } from "./customized.vue?vue&type=template&id=4324c2cc&scoped=true&"
import script from "./customized.vue?vue&type=script&lang=js&"
export * from "./customized.vue?vue&type=script&lang=js&"
import style0 from "./customized.vue?vue&type=style&index=0&id=4324c2cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4324c2cc",
  null
  
)

export default component.exports